import { useRef, type ReactNode } from 'react';
import { AnimatedLabel } from '../ui/AnimatedLabel';
import './AnswerFeedback.css';

/** Preserve the last feedback during collapse so both text and layout can ease away. */
export function AnswerFeedback({ id, message, children }: { id: string; message: string | null; children?: ReactNode }) {
  const lastMessage = useRef(message);
  if (message) lastMessage.current = message;
  const visible = Boolean(message);
  return <div id={id} role="alert" aria-atomic="true" aria-hidden={!visible} inert={!visible}
    className="conversation-answer-feedback text-sm text-danger" data-visible={visible}>
    <div><div className="conversation-answer-feedback-content"><AnimatedLabel text={lastMessage.current ?? ''} multiline />{children}</div></div>
  </div>;
}
